import { match } from 'ts-pattern';

import { FEATURE } from '~/common/enums/feature.enum';
import { useTreatments } from '~/domains/common/hooks/useTreatments';
import HomeSkeletonLayout from '~/domains/home/components/HomeSkeleton';
import HomeContests from '~/domains/home/Contests';
import HomeFeaturedContests from '~/domains/home/Featured';

import type { HomeCollectionSlug } from '../../constants/query';
import { CondensedCarouselCollection } from '../CondensedCarouselCollection/CondensedCarouselCollection';

type CondensedCarouselsSlotProps = {
  slug: HomeCollectionSlug;
  order?: number;
};

export function CondensedCarouselsSlot({ slug, order }: CondensedCarouselsSlotProps) {
  const { isSettled, treatments } = useTreatments([FEATURE.ENABLE_CONDENSED_CAROUSELS_WEB]);

  if (!isSettled) {
    return <HomeSkeletonLayout isLoading order={order ?? 0} />;
  }

  const isTreatment = treatments[FEATURE.ENABLE_CONDENSED_CAROUSELS_WEB]?.treatment === 'on';
  if (isTreatment) {
    return <CondensedCarouselCollection slug={slug} order={order} />;
  }

  return match(slug)
    .with('featured', () => <HomeFeaturedContests order={order} />)
    .with('homepage', () => <HomeContests order={order} />)
    .exhaustive();
}
